import { InvalidationManager } from '@enklakassan/mobx-hooks';

const invalidationManager = new InvalidationManager();

export default invalidationManager;
